import React, { useContext } from 'react';
import { useTheme } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import { ColorModeContext } from '../ColorModeContext';

export default function ThemeToggleButton() {
    const theme = useTheme();
    const colorMode = useContext(ColorModeContext);

    return (
        <IconButton
            sx={{
                ml: 1,
                transition: 'transform 0.3s ease-in-out',
                color: (theme) => theme.palette.text.primary,
                background: (theme) => theme.palette.mode === 'light' ? 'rgba(0,0,0,0.04)' : 'rgba(255,255,255,0.04)',
                '&:hover': {
                    transform: 'rotate(45deg)',
                    background: (theme) => theme.palette.mode === 'light' ? 'rgba(0,0,0,0.10)' : 'rgba(255,255,255,0.10)',
                },
            }}
            onClick={colorMode.toggleColorMode}
        >
            {theme.palette.mode === 'dark' ? <Brightness7Icon sx={{ color: theme.palette.text.primary }} /> : <Brightness4Icon sx={{ color: theme.palette.text.primary }} />}
        </IconButton>
    );
}